export default __webpack_public_path__ + "static/media/test-foto2.058304c0.jpg";